module.exports = __webpack_public_path__ + "static/img/ilustracao_erro.977261e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ilustracao_erro.svg
// module id = hIOD
// module chunks = 0